// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { GameEventWire, GameEventWireT } from '../mannequin/game-event-wire';
import { LimitsWire, LimitsWireT } from '../mannequin/limits-wire';
import { TrackingFrameWire, TrackingFrameWireT } from '../mannequin/tracking-frame-wire';


export class TrackingDataWire implements flatbuffers.IUnpackableObject<TrackingDataWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):TrackingDataWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsTrackingDataWire(bb:flatbuffers.ByteBuffer, obj?:TrackingDataWire):TrackingDataWire {
  return (obj || new TrackingDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsTrackingDataWire(bb:flatbuffers.ByteBuffer, obj?:TrackingDataWire):TrackingDataWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TrackingDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

version():string|null
version(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
version(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

frames(index: number, obj?:TrackingFrameWire):TrackingFrameWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new TrackingFrameWire()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

framesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

limits(obj?:LimitsWire):LimitsWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new LimitsWire()).__init(this.bb_pos + offset, this.bb!) : null;
}

eventKeyFrame(index: number, obj?:GameEventWire):GameEventWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new GameEventWire()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

eventKeyFrameLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startTrackingDataWire(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addVersion(builder:flatbuffers.Builder, versionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, versionOffset, 0);
}

static addFrames(builder:flatbuffers.Builder, framesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, framesOffset, 0);
}

static createFramesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startFramesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addLimits(builder:flatbuffers.Builder, limitsOffset:flatbuffers.Offset) {
  builder.addFieldStruct(2, limitsOffset, 0);
}

static addEventKeyFrame(builder:flatbuffers.Builder, eventKeyFrameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, eventKeyFrameOffset, 0);
}

static createEventKeyFrameVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startEventKeyFrameVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endTrackingDataWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static finishTrackingDataWireBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset);
}

static finishSizePrefixedTrackingDataWireBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, undefined, true);
}


unpack(): TrackingDataWireT {
  return new TrackingDataWireT(
    this.version(),
    this.bb!.createObjList<TrackingFrameWire, TrackingFrameWireT>(this.frames.bind(this), this.framesLength()),
    (this.limits() !== null ? this.limits()!.unpack() : null),
    this.bb!.createObjList<GameEventWire, GameEventWireT>(this.eventKeyFrame.bind(this), this.eventKeyFrameLength())
  );
}


unpackTo(_o: TrackingDataWireT): void {
  _o.version = this.version();
  _o.frames = this.bb!.createObjList<TrackingFrameWire, TrackingFrameWireT>(this.frames.bind(this), this.framesLength());
  _o.limits = (this.limits() !== null ? this.limits()!.unpack() : null);
  _o.eventKeyFrame = this.bb!.createObjList<GameEventWire, GameEventWireT>(this.eventKeyFrame.bind(this), this.eventKeyFrameLength());
}
}

export class TrackingDataWireT implements flatbuffers.IGeneratedObject {
constructor(
  public version: string|Uint8Array|null = null,
  public frames: (TrackingFrameWireT)[] = [],
  public limits: LimitsWireT|null = null,
  public eventKeyFrame: (GameEventWireT)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const version = (this.version !== null ? builder.createString(this.version!) : 0);
  const frames = TrackingDataWire.createFramesVector(builder, builder.createObjectOffsetList(this.frames));
  const eventKeyFrame = TrackingDataWire.createEventKeyFrameVector(builder, builder.createObjectOffsetList(this.eventKeyFrame));

  TrackingDataWire.startTrackingDataWire(builder);
  TrackingDataWire.addVersion(builder, version);
  TrackingDataWire.addFrames(builder, frames);
  TrackingDataWire.addLimits(builder, (this.limits !== null ? this.limits!.pack(builder) : 0));
  TrackingDataWire.addEventKeyFrame(builder, eventKeyFrame);

  return TrackingDataWire.endTrackingDataWire(builder);
}
}
